import { IAppState, ISeoState } from '../common/state';

export function selectSeo(state: IAppState): ISeoState {
  return state.results.seo;
}
